export default {"src":"//_next/static/media/cloud.3b620523.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};